import { API } from "../store";
import { openSnackBar } from "./snack-bar";
import { doRefresh } from "./authentication";
import { getAddressForPanic, getAddress } from "./users";
import constant from "../config/constant";
const {
  MESSAGE: { PREMIUM_FAIL, BLOCKED_USER },
  ERROR_CODE,
  ERROR_STATUS,
} = constant;

export const addEventAttendee = (attendeeID, eventID) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const attendeeObj = {
      users_id: attendeeID,
    };
    API.post(`/events/${eventID}/attendees`)
      .send(attendeeObj)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response;
      })
      .then((res) => res.body)
      .then((data) => {
        if (data.message === "events create attendee success") {
          dispatch(doRefresh);
        } else {
          throw new Error("FAILED TO CREATE EVENT");
        }
        resolve(data);
      })
      .catch((err) => {
        if (err.response.body.message === "events create attendee error") {
          dispatch(
            openSnackBar({
              message: "Cannot be own attendee",
            })
          );
        }
        reject(err);
      });
  });
};

export const updateEvent = (addressParts, attendeeID, eventID, lat, lng) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    API.put(`/events/${Number(eventID)}`)
      .send({ ...addressParts, lat, lng })
      .then((res) => {
        if (!res.ok) throw Error(res.statusText);
        return res.body;
      })
      .then((data) => {
        if (data.message === "events update success") {
          if (attendeeID) {
            dispatch(addEventAttendee(attendeeID, eventID))
              .then((res) => {
                dispatch(doRefresh()).then((res) => {
                  dispatch(
                    openSnackBar({
                      message: "Showing Updated",
                    })
                  );
                  resolve(data);
                });
              })
              .catch((err) => {
                reject(err);
              });
          } else {
            resolve(true);
          }

          // gets user... for timer page

          // dispatch(
          //   openSnackBar({
          //     message: 'Showing Updated'
          //   })
          // )
          // resolve(data)
        } else {
          dispatch(
            openSnackBar({
              message: "FAILED TO UPDATE EVENT",
            })
          );
          // throw new Error('FAILED TO UPDATE EVENT')
          reject(data);
        }
      })
      .catch((err) => reject(err));
  });
};

export const updateExsistingEvent = (
  addressParts,
  attendeeID,
  eventId,
  notes
) => (dispatch) => {
  API.put(`/events/${eventId}`)
    .send({ ...addressParts, notes })
    .then((res) => {
      if (!res.ok) throw Error(res.statusText);
      return res.body;
    })
    .then((data) => {
      if (data.message === "events update success") {
        dispatch(doRefresh());
        dispatch(
          openSnackBar({
            message: "Showing Updated",
          })
        );
      } else {
        dispatch(
          openSnackBar({
            message: "FAILED TO UPDATE EVENT",
          })
        );
        throw new Error("FAILED TO UPDATE EVENT");
      }
    })
    .catch((err) => console.log("err", err));
};

// STARTS TIMER
export const startEvent = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.get(`/events/${id}/start`)
      .then((res) => {
        if (!res.ok) throw Error(res.statusText);
        return res.body;
      })
      .then((data) => {
        if (data.message === "events start success") {
          dispatch(
            openSnackBar({
              message: "Timer Started",
            })
          );
          resolve(data);
        } else {
          dispatch(
            openSnackBar({
              message: "FAILED TO START EVENT",
            })
          );
          reject(data);
          // throw new Error('FAILED TO START EVENT')
        }
      })
      .catch((err) => reject(err));
  });
};

export const createAndStartEvent = (addressParts, history, delay) => (
  dispatch
) => {
  API.post("/events")
    .send({ ...addressParts, delay })
    .then((res) => {
      if (!res.ok) {
        throw Error(res.statusText);
      }
      return res.body;
    })
    .then((data) => {
      if (data.message === "events create success") {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            dispatch(
              getAddress(
                position.coords.latitude,
                position.coords.longitude,
                (b, a, obj) => {
                  if (obj) {
                    dispatch(
                      updateEvent(
                        obj,
                        null,
                        data.id,
                        position.coords.latitude,
                        position.coords.longitude
                      )
                    )
                      .then((res) => {
                        return dispatch(startEvent(data.id));
                      })
                      .then((res) => {
                        history.push({
                          pathname: `/showings/timer/${data.id}`,
                          state: delay,
                        });
                      })
                      .catch((err) => {
                        history.push(`/showings/start/${data.id}`);
                      });
                  } else {
                    history.push(`/showings/start/${data.id}`);
                  }
                }
              )
            );
          },
          (err) =>
            history.push({
              pathname: `/showings/start/${data.id}`,
              state: delay,
            })
        );

        // disable start showing
        // dispatch(startEvent(data.id))
        // dispatch(doRefresh())
      } else {
        throw new Error("FAILED TO CREATE EVENT");
      }
    })
    .catch((err) => {
      if (err.status === ERROR_CODE) {
        dispatch(
          openSnackBar({
            message: PREMIUM_FAIL,
          })
        );
      }
      if (err.status === ERROR_STATUS) {
        dispatch({ type: "LOGOUT" });
        localStorage.clear();
        dispatch(
          openSnackBar({
            message: err.response.body.type || BLOCKED_USER,
          })
        );
      }
    });
};

// ENDS TIMER
export const endEvent = (event_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.get(`/events/${event_id}/end`)
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.body;
      })
      .then((data) => {
        if (data.message === "events end success") {
          dispatch(
            openSnackBar({
              message: "Showing Ended",
            })
          );
          resolve(data);
        } else {
          dispatch(
            openSnackBar({
              message: "FAILED TO END EVENT",
            })
          );
          reject(data);
          throw new Error("FAILED TO END EVENT");
        }
        dispatch(doRefresh());
      })
      .catch((err) => reject(err));
  });
};

export const deleteEvent = (event_id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API.delete(`/events/${event_id}`)
      .then((res) => {
        if (!res.ok) {
          throw Error(res.statusText);
        }
        return res.body;
      })
      .then((data) => {
        if (data.message === "events delete success") {
          dispatch(
            openSnackBar({
              message: "Showing Canceled",
            })
          );
          resolve(data);
        } else {
          dispatch(
            openSnackBar({
              message: "FAILED TO DELETE EVENT",
            })
          );
          reject(data);
        }
        dispatch(doRefresh());
      })
      .catch((err) => reject(err));
  });
};

// TODO add 5 minute reminder instead of 1

export const resetEvent = (match, interval, attendee, lati, lngi, delay) => (
  dispatch,
  getState
) => {
  console.log(interval, "intaerval action");
  return new Promise((resolve, reject) => {
    // if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        console.log("perfect");
        let lat = position.coords.latitude;
        let lng = position.coords.longitude;
        let user_id = "",
          first_name = "",
          last_name = "";
        if (typeof attendee === "object" && attendee !== null) {
          user_id = attendee.id;
          first_name = attendee.first_name;
          last_name = attendee.last_name;
        }
        dispatch(getAddressForPanic(lat, lng))
          .then((addressObject) => {
            API.post(`/events/${match.params.id}/reset`)
              .send({
                lat,
                lng,
                ...addressObject,
                user_id,
                first_name,
                last_name,
                delay,
              })
              .then((response) => {
                if (!response.ok) {
                  reject(response);
                  throw Error(response.statusText);
                }
                clearInterval(interval);
                resolve(response);
              })
              .catch((err) => {
                clearInterval(interval);
                reject(err);
              });
          })
          .catch((err) => console.log("err>>>>>>>>>", err));
      },
      (err) => {
        console.log("error");
        let user_id = "",
          first_name = "",
          last_name = "";
        if (typeof attendee === "object" && attendee !== null) {
          user_id = attendee.id;
          first_name = attendee.first_name;
          last_name = attendee.last_name;
        }
        dispatch(getAddressForPanic(lati, lngi))
          .then((addressObject) => {
            API.post(`/events/${match.params.id}/reset`)
              .send({
                lati,
                lngi,
                ...addressObject,
                user_id,
                first_name,
                last_name,
                delay,
              })
              .then((response) => {
                if (!response.ok) {
                  reject(response);
                  throw Error(response.statusText);
                }
                clearInterval(interval);
                resolve(response);
              })
              .catch((err) => {
                clearInterval(interval);
                reject(err);
              });
          })
          .catch((err) => console.log("err>>>>>>>>>", err));
      }
    );
    // } else {
    //   let user_id = "",
    //       first_name = "",
    //       last_name = ""
    //     if (typeof attendee === "object" && attendee !== null) {
    //       user_id = attendee.id
    //       first_name = attendee.first_name
    //       last_name = attendee.last_name
    //     }
    //   dispatch(getAddressForPanic(lati, lngi)).then(addressObject => {
    //     API.post(`/events/${match.params.id}/reset`)
    //       .send({ lati, lngi, ...addressObject, user_id, first_name, last_name })
    //       .then(response => {
    //         if (!response.ok) {
    //           reject(response)
    //           throw Error(response.statusText)
    //         }

    //         clearInterval(interval)
    //         resolve(response)
    //       })
    //       .catch(err => {
    //         clearInterval(interval)
    //         reject(err)
    //       })
    //   })
    //   .catch(err => console.log('err>>>>>>>>>', err))
    // }
  });
};

export const getEvents = (id) => {
  return (dispatch) => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/events`)
          .then((response) => response.body)
          .then((response) => {
            if (response.message === "events list success") {
              resolve(response);
            } else {
              reject("not found");
            }
          });
      };
      call();
    });
    return deferred;
  };
};
